import React from 'react'
import { Main } from '../AcademicCurriculum/AcademicCurriculum.element'
import { Directortext } from '../Codeofconduct/Code.element'
import { Directorbackground, Sub } from './Vission.element'

function Vission() {
    return (
        <Main>
                   <Directorbackground>
                <Directortext>
                    {/* <h1>Vision</h1>
                    <p>The New Era Public School| <span>Vision</span> </p> */}
                </Directortext>
      
            </Directorbackground> 

            <Sub>
                <p>
                To serve the cause of education by preparing enlightened individuals equipped with knowledge, abilities and skills to effectively operate as responsible d productive citizens and leaders in diverse environments by integrating emerging pedagogies and technologies, creativity, values, research and ethical practices.
                </p>
             


             
            </Sub>
        </Main>
    )
}

export default Vission
